// extracted by mini-css-extract-plugin
module.exports = {"overlay":"routeChangeGuard_overlay__2MyCB","confirmation":"routeChangeGuard_confirmation__6Mf3z"};